// src/lib/firebase.ts
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { NEXT_PUBLIC_RECAPTCHA_SITE_KEY } from './config';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCKsI5Wf8S41nZp7uI9BDN-GFTBr_MYG3s",
  authDomain: "divebalanze.firebaseapp.com",
  projectId: "divebalanze",
  storageBucket: "divebalanze.appspot.com",
  messagingSenderId: "809691112127",
  appId: "1:809691112127:web:cc339eb5dc4170b3acdc0a"
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);

// New function to initialize App Check on the client
export function initializeAppCheckOnClient() {
  if (typeof window !== 'undefined') {
    const siteKey = NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
    if (!siteKey) {
      console.error("Firebase App Check: NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not set.");
      return;
    }
    
    // Check if App Check is already initialized to prevent re-initialization
    try {
        getApp(app.name); // This will throw if the app is not initialized.
        // If we are here, the app is initialized. Now check App Check.
        // Unfortunately, there's no public `getAppCheck()` so we use a flag.
        if ((window as any).isAppCheckInitialized) {
            return;
        }
    } catch(e) {
        // App not found, something is wrong, but let initialization proceed to throw its own error.
    }

    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true
    });
    (window as any).isAppCheckInitialized = true;
  }
}

export { app, auth, db };
